import Vue from 'vue'
import Router from 'vue-router'

import Layout from '@/components/layout'


// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
  base: '/HNweb/',

  routes: [
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '/',
          component: () => import(/* webpackChunkName:"index"*/'@/views/home/index'),
        },
        {
          path: 'product',
          name: 'Product',
          component: () => import(/* webpackChunkName:"product"*/'@/views/product/index'),
        },
        {
          path: '/product/productCenter',
          name: 'productCenter',
          component: () => import(/* webpackChunkName:"productCenter"*/'@/views/product/productCenter'),
        },
        {
          path: '/product/aiAnswer',
          name: 'aiAnswer',
          component: () => import(/* webpackChunkName:"aiAnswer"*/'@/views/product/aiAnswer'),
        },
        {
          path: '/product/sanitationSystem',
          name: 'sanitationSystem',
          component: () => import(/* webpackChunkName:"sanitationSystem"*/'@/views/product/sanitationSystem'),
        },
        {
          path: 'product/management',
          name: 'Management',
          component: () => import(/* webpackChunkName:"management"*/'@/views/product/management'),
        },
        {
          path: 'product/enforcement',
          name: 'Enforcement',
          component: () => import(/* webpackChunkName:"enforcement"*/'@/views/product/enforcement'),
        },
        {
          path: 'product/citySafety',
          name: 'CitySafety',
          component: () => import(/* webpackChunkName:"citySafety"*/'@/views/product/citySafety'),
        },
        {
          path: 'product/commandCoord',
          name: 'CommandCoord',
          component: () => import(/* webpackChunkName:"commandCoord"*/'@/views/product/commandCoord'),
        },
        {
          path: 'product/comprehensiveEvaluat',
          name: 'ComprehensiveEvaluat',
          component: () => import(/* webpackChunkName:"comprehensiveEvaluat"*/'@/views/product/comprehensiveEvaluat'),
        },
        {
          path: 'product/mimicryGrid',
          name: 'MimicryGrid',
          component: () => import(/* webpackChunkName:"mimicryGrid"*/'@/views/product/mimicryGrid'),
        },
        {
          path: 'product/commandDispatch',
          name: 'CommandDispatch',
          component: () => import(/* webpackChunkName:"commandDispatch"*/'@/views/product/commandDispatch'),
        },
        {
          path: 'product/landscaping',
          name: 'Landscaping',
          component: () => import(/* webpackChunkName:"landscaping"*/'@/views/product/landscaping'),
        },
        {
          path: 'product/smartSanitation',
          name: 'SmartSanitation',
          component: () => import(/* webpackChunkName:"smartSanitation"*/'@/views/product/smartSanitation'),
        },
        {
          path: 'product/publicApplication',
          name: 'PublicApplication',
          component: () => import(/* webpackChunkName:"publicApplication"*/'@/views/product/publicApplication'),
        },
        {
          path: 'product/ARInspection',
          name: 'ARInspection',
          component: () => import(/* webpackChunkName:"ARInspection"*/'@/views/product/ARInspection'),
        },
        {
          path: 'product/dangerousGas',
          name: 'DangerousGas',
          component: () => import(/* webpackChunkName:"dangerousGas"*/'@/views/product/dangerousGas'),
        },
        
        {
          path: 'aiInspection',
          name: 'AiInspection',
          component: () => import(/* webpackChunkName:"aiInspection"*/'@/views/aiInspection/index'),
        },
        {
          path: 'typicalCases',
          name: 'TypicalCases',
          component: () => import(/* webpackChunkName:"typicalCases"*/'@/views/typicalCases/index'),
        },
        {
          path: 'typicalCases/casedetail',
          name: 'CaseDetail',
          component: () => import(/* webpackChunkName:"casedetail"*/'@/views/typicalCases/casedetail'),
        },
        {
          path: 'news',
          name: 'News',
          component: () => import(/* webpackChunkName:"News"*/'@/views/news/index'),
        },
        {
          path: 'news/newsdetail',
          name: 'NewsDetail',
          component: () => import(/* webpackChunkName:"newsdetail"*/'@/views/news/newsdetail'),
        },
        {
          path: 'news/videodetail',
          name: 'videodetail',
          component: () => import(/* webpackChunkName:"videodetail"*/'@/views/news/videodetail'),
        },
        {
          path: 'support',
          name: 'Support',
          component: () => import(/* webpackChunkName:"support"*/'@/views/support/index'),
        },
        {
          path: 'about',
          name: 'About',
          component: () => import(/* webpackChunkName:"about"*/'@/views/about/index'),
        },
        {
          path: 'about/mienList',
          name: 'MienList',
          component: () => import(/* webpackChunkName:"mienList"*/'@/views/about/mienList'),
        },
        {
          path: 'joins',
          name: 'Joins',
          component: () => import(/* webpackChunkName:"joins"*/'@/views/joins/index'),
        },


        {
          path: 'show',
          name: 'Show',
          component: () => import(/* webpackChunkName:"show"*/'@/views/show'),
        },
        {
          path: 'resolve1',
          name: 'Resolve1',
          component: () => import(/* webpackChunkName:"resolve1"*/'@/views/resolve1'),
        },
        {
          path: 'joinform',
          name: 'JoinForm',
          component: () => import(/* webpackChunkName:"joinform"*/'@/views/joinform'),
        }, {
          path: 'joinSuccess',
          name: 'JoinSuccess',
          component: () => import(/* webpackChunkName:"joinSuccess"*/'@/views/joinSuccess'),
        }

      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js